module.exports = __webpack_public_path__ + "static/img/explainer-video2.86f94fe.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/blast/explainer-video2.jpg
// module id = jLPS
// module chunks = 1